import {SCHEME} from '@zzng/common/constants/scheme';
import {createOpenDigitalCardScheme} from '@zzng/common/scheme/digitalcard';
import {openExternalWebview} from '@zzng/common/scheme/web';
import {appendQueryParamToUrl} from '@zzng/common/utils/common';

const createOpenDigitalDocsScheme = (url: string) => {
  return `${SCHEME.DIGITAL_DOCS}?url=${encodeURIComponent(url)}`;
};

type OpenPapasWebviewArgs = {
  /** 현재 열린 웹뷰를 닫고 파파스를 열지 확인 */
  isCurrentWebviewClose: boolean;
  /** 파파스 웹뷰 URL */
  papasUrl: string;
  /** 파파스 발급에 필요한 트랜잭션 ID */
  papasTxId: string;
  /** 파파스 발급 후 돌아올 정보 */
  papasReturnUrl: {
    /** 돌아올 URL */
    url: string;
    params: {
      /** 카드타입(디카롱에서 사용) */
      cardType?: string;
      /** 발급 업데이트 유무(톡사원증에서 사용) */
      update?: boolean;
      /** 재발급 여부(디카롱에서 사용) */
      reissue?: boolean;
      /** 티아라 출처 */
      t_src?: string | null;
      /** 티아라 채널 */
      t_ch?: string | null;
      /** 티아라 객체 */
      t_obj?: string | null;
    };
  };
};

export const openPapasWebview = ({
  isCurrentWebviewClose,
  papasUrl,
  papasTxId,
  papasReturnUrl
}: OpenPapasWebviewArgs) => {
  const url = appendQueryParamToUrl(papasReturnUrl.url, {papasTxId, ...papasReturnUrl.params});

  // 돌아올 URL은 스킴으로 전달한다.
  const returnUrlScheme = encodeURIComponent(createOpenDigitalCardScheme({url, target: '_blank'}));

  const digitaldocsScheme = createOpenDigitalDocsScheme(`${papasUrl}?txId=${papasTxId}&returnUrl=${returnUrlScheme}`);

  openExternalWebview(digitaldocsScheme, {isCurrentWebviewClose});
};
